import { Reveal } from "@/components/common/Reveal";
import { ProjetHero, SaviezVous, ProjetCta } from "@/components/projet/ProjetShared";
import { Check } from "lucide-react";

const VALUES = [
    "Le bien-être animal améliore la performance.",
    "L'écoconstruction renforce la durabilité.",
    "L'esthétique valorise l'exploitation.",
    "L'intelligence du bâti facilite le travail quotidien.",
];

export default function ProjetAgricole() {
    return (
        <main data-testid="projet-agricole-page">
            <ProjetHero
                overline="Chez ROZIER CONCEPT, agricole et haras"
                title="Concevoir juste, construire durablement, élever sereinement."
                img="/images/cattle.jpg"
                alt="Stabulation bovine moderne"
            />

            <section className="bg-rz-bg py-24 lg:py-32 px-6 md:px-12">
                <div className="mx-auto max-w-[1400px] grid gap-12 lg:grid-cols-12 lg:gap-16 items-start">
                    <div className="lg:col-span-6">
                        <Reveal>
                            <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                                Notre vision
                            </span>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="font-display mt-5 text-[clamp(1.9rem,4vw,3.2rem)] font-bold tracking-tight leading-[1.08] text-rz-ink">
                                Nous construisons pour les générations futures.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.18}>
                            <p className="mt-6 text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                                L'agriculture évolue constamment. Les bâtiments que nous concevons
                                aujourd'hui doivent être capables de répondre aux enjeux de demain.
                            </p>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-6 lg:pt-3">
                        <Reveal delay={0.2}>
                            <p className="text-base lg:text-lg leading-relaxed text-rz-ink-soft mb-6">
                                Chez ROZIER CONCEPT, agricole et haras, nous croyons en une
                                agriculture où :
                            </p>
                            <ul className="space-y-4">
                                {VALUES.map((v) => (
                                    <li key={v} className="flex items-start gap-3">
                                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rz-green text-white">
                                            <Check size={14} />
                                        </span>
                                        <span className="text-base text-rz-ink-soft">{v}</span>
                                    </li>
                                ))}
                            </ul>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="bg-white py-24 lg:py-32 px-6 md:px-12">
                <div className="mx-auto max-w-[1400px]">
                    <Reveal>
                        <div className="rounded-[2rem] bg-rz-green px-8 py-12 md:px-16 md:py-16 text-center">
                            <p className="font-display mx-auto max-w-4xl text-[clamp(1.4rem,3vw,2.2rem)] font-bold leading-snug text-white">
                                Créons ensemble vos stabulations et vos hangars : l'équilibre entre
                                vos besoins agricoles, le bien-être animal et la performance, avec
                                un budget maîtrisé et aux normes en vigueur.
                            </p>
                        </div>
                    </Reveal>

                    <div className="mt-20 grid gap-12 lg:grid-cols-12 lg:gap-16 items-center">
                        <div className="lg:col-span-6">
                            <Reveal>
                                <div className="overflow-hidden rounded-[2rem]">
                                    <img
                                        src="/images/equestrian2.jpg"
                                        alt="Charpente bois sur mesure"
                                        className="h-full w-full object-cover aspect-[4/3] transition-transform [transition-duration:1200ms] hover:scale-105"
                                    />
                                </div>
                            </Reveal>
                        </div>
                        <div className="lg:col-span-6">
                            <Reveal>
                                <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                                    Construction bois
                                </span>
                            </Reveal>
                            <Reveal delay={0.1}>
                                <h2 className="font-display mt-5 text-[clamp(1.8rem,3.5vw,2.8rem)] font-bold tracking-tight leading-[1.08] text-rz-ink">
                                    Tout commence par le bois.
                                </h2>
                            </Reveal>
                            <Reveal delay={0.16}>
                                <p className="mt-6 text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                                    Naturel et sain, le bois est la base d'une écoconstruction
                                    durable : une ventilation optimisée et une performance
                                    zootechnique du bâtiment.
                                </p>
                                <p className="mt-5 text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                                    Nos charpentes sur mesure en bois offrent naturel et esthétique,
                                    tout en assurant une isolation thermique et phonique.
                                </p>
                            </Reveal>
                            <Reveal delay={0.22}>
                                <div className="mt-8">
                                    <SaviezVous />
                                </div>
                            </Reveal>
                        </div>
                    </div>
                </div>
            </section>

            <ProjetCta text="Concevons ensemble votre exploitation de demain." />
        </main>
    );
}
